import { render, staticRenderFns } from "./offer-demo.vue?vue&type=template&id=0b2cb6a0&scoped=true&"
var script = {}
import style0 from "./offer-demo.vue?vue&type=style&index=0&id=0b2cb6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cb6a0",
  null
  
)

export default component.exports